import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-人",
  "use": "icon-人-usage",
  "viewBox": "0 0 32.1 36.91",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32.1 36.91\" id=\"icon-人\"><title>我的_实</title><path d=\"M8,42.46c0-.27,0-.53,0-.8A16,16,0,0,1,20.84,25.92a10.43,10.43,0,1,1,6.31,0A16,16,0,0,1,40,41.65c0,.27,0,.53,0,.8Z\" transform=\"translate(-7.95 -5.54)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol